export const HighlightIqTeamSide = {
	HOME: 'home',
	AWAY: 'away',
};
